import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey4 } from 'approot/shared/styles/colours.style';
import {
  spacing8,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import {
  ActivityBuilderDrawerClose,
  ActivityBuilderDrawerHeader,
} from 'approot/activity-builder/activity-builder-drawer.style';
import { DropdownItemFlex } from 'approot/shared/dropdown/dropdown-item.style';
import {
  baseFlexCss,
  flexCentreAlignCss,
  flexRightAlignCss,
} from 'approot/shared/styles/flex.style';
import { BlackDiamondWrapper } from 'approot/shared/differentiation/differentiation.style';

export const DrawerViewFooter = styled.div`
  ${flexCentreAlignCss}
  width: 100%;
  padding: ${rem(spacing24)};
  border-top: 1px solid ${grey4};
  flex-direction: column;
`;

export const DrawerViewButtons = styled.div`
  ${flexRightAlignCss}
  width: 100%;
  gap: ${rem(spacing8)};
`;

export const DrawerViewHeader = styled(ActivityBuilderDrawerHeader)`
  justify-content: center;
  padding: 0;
  height: ${rem(64)};
`;

export const DrawerViewClose = styled(ActivityBuilderDrawerClose)`
  position: absolute;
  left: ${rem(spacing16)};
`;

export const DrawerViewDropdownItem = styled(DropdownItemFlex)``;

export const DrawerViewDropdownSelected = styled.span`
  ${baseFlexCss}

  ${BlackDiamondWrapper} {
    // add space for the rotated square
    margin-left: ${rem(2)};
  }
`;
